'use client';

// Read-only повтор сохранённого диалога генератора (админка «Диалоги»):
// тот же ChatMessages в том же контейнере, что на лендинге, — бабблы/схемы/подбор
// моделей выглядят 1-в-1. Интерактив выключен: варианты-кнопки — no-op, CTA — «#».
import { useRef } from 'react';
import styles from './generator.module.css';
import { ChatMessages, type Msg } from './chat-view';
import { type GeneratorDict } from './schema';

interface Props {
  messages: Msg[];
  dict: GeneratorDict;
  markSrc?: string;
  acceptHref?: string;
}

export function DialogReplay({
  messages,
  dict,
  // Новый знак (владелец 10.08.2026), как у Generator: прежний круг #e23570 удалён.
  markSrc = '/logo-192.png',
  acceptHref = '#',
}: Props) {
  const lastBotRef = useRef<HTMLDivElement | null>(null);
  return (
    <div className={styles.composer}>
      <div className={`${styles.chat} ${styles.show} ${styles.replay}`}>
        <div className={styles.chatIn}>
          <div className={styles.chatPad}>
            <ChatMessages
              messages={messages}
              dict={dict}
              markSrc={markSrc}
              acceptHref={acceptHref}
              onOption={() => {}}
              lastBotRef={lastBotRef}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
